export default __webpack_public_path__ + "static/media/logonetflix.2ea6959d.png";